<script setup>
import { computed, onMounted, ref, watch } from 'vue'
import { Button } from '@components'

import { useAppointments } from '@store/appointments.js'
const $appointments = useAppointments()

import { useSettings } from '@store/settings.js'
const $settings = useSettings()

import { useCustomizer } from '@store/customizer.js'
const $customizer = useCustomizer()

import ServiceLoader from './ServiceLoader.vue'
import ServiceItem from './ServiceItem.vue'
import Main from '@views/booking/layout/Main.vue'


onMounted(async () => {
    // $appointments.matchAppointmentPreRequirement()
    await $appointments.fetchServices()
})

const filterServices = computed(() => {
    // Get the services array from $appointments
    const services = $appointments.services || []

    const catPriority = (catId) => {
        return $appointments.categories.find(cat => cat.category_id === catId)?.priority || 0
    }

    // Sort services by category_id and then by order within each category
    services.sort((a, b) => {
        if (catPriority(a.category_id) < catPriority(b.category_id)) {
            return -1
        } else if (catPriority(a.category_id) > catPriority(b.category_id)) {
            return 1
        } else {
            // If category_id is the same, sort by 'order'
            return a.order - b.order
        }
    })

    return services
})

const wrapperClass = computed(() => {
    switch ($settings.customizer.service.layout_type) {
        case 'row01':
            return 'service-list-wrapper-row'
        case 'grid01':
            return 'service-list-wrapper-grid'
        default:
            return 'service-list-wrapper-row'
    }
})

const submitService = (service_id, btnClick = false) => {
    if (!service_id) return
    $appointments.setAppointment('service_id', service_id)

    // bail if widget but no button click
    if ($settings.isWidget && !btnClick) return

    $appointments.nextStep()
}

// set service when there is only one
watch(() => filterServices, () => {
    if (filterServices.value.length == 1) {
        submitService(filterServices.value[0].service_id)
    }
}, { deep: true })
</script>

<template>
    <Main>
        <template #content>
            <div class="service-page-title" :style="$customizer.titleStyle">{{ $settings.customizer.service.title || '' }}</div>
            <!-- empty service loader -->
            <ServiceLoader v-if="!$appointments.isServiceLoaded" />

            <!-- service list -->
            <div v-if="$appointments.isServiceLoaded" :class="wrapperClass">
                <ServiceItem v-for="(service, index) in filterServices" :key="index" :service="service" @select="(service) => submitService(service.service_id)" />
            </div>
        </template>

        <template #footer v-if="$settings.isWidget">
            <Button @click="submitService($appointments.selectedService.service_id, true)" type="primary" size="md" radius="square" class="w-full">Continue</Button>
        </template>
    </Main>
</template>